export const MAX_PASSWORD_LENGTH = 20
export const MIN_PASSWORD_LENGTH = 8
